/* eslint-disable import/no-named-as-default */
/* eslint-disable global-require */
/* eslint-disable no-underscore-dangle */
/* global window */

import './webpack-public-url';
import { watchForNewToken } from '@markit/web-component-bootstrap';

import format from 'Utils/format';

import 'assets/styles/bootstrap/bootstrap.scss';
import 'assets/styles/index.scss';

// initing an instance of format that will have global props set
// removing the need to import it in every file.
// https://format.dev.services.mdgapp.net/
window.format = format;

watchForNewToken('md', ({ nextToken }) => window.localStorage.setItem('access_token', nextToken));

require('./AnalystReportsOverview').default();
require('./MarketsInsightsOverview').default();
require('./MarketsNewsHeadlines').default();
require('./MarketsOverview').default();
require('./MyWatchlistsWidget').default();
require('./AccountHoldingsDrawer').default();
